<template>
  <div class="flex act-container">
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <h4>基本信息</h4>
          <el-form-item label="项目分类">
            <el-select
              size="small"
              style="width: 400px"
              clearable
              placeholder="请选择项目分类"
              v-model="ruleForm.projectTypeId"
            >
              <el-option
                :label="v.serviceType"
                :value="v.id"
                v-for="(v, i) in serviceTypeList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务名称" prop="serviceName">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.serviceName"
              placeholder="请输入服务名称(8字以内)"
              maxlength="8"
            ></el-input>
          </el-form-item>

          <el-form-item label="服务编码" >
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.serviceCode"
              placeholder="最长8个字符，英文+数字，分类+编码，组成分类编码"
              maxlength="8"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="显示排序">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.sort"
              placeholder="数字越小越靠前"
              maxlength="8"
            ></el-input>
          </el-form-item>


          <el-form-item label="服务描述">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.serviceDescribe"
              placeholder="请填写服务描述"
              maxlength="100"
            ></el-input>
          </el-form-item>


          <el-form-item label="服务时长" prop="serviceDuration">
            <el-input
              v-model.number="ruleForm.serviceDuration"
              type="number"
              min="1"
              oninput="if(value<1)value=''"
              placeholder="请输入大于0的数字"
              size="small"
              clearable
            ></el-input>
            <span class="form-tip">分钟</span>
            <!-- <el-select
              size="small"
              style="width: 400px"
              clearable
              placeholder="请选择服务时长"
              v-model="ruleForm.serviceDuration"
            >
            <el-option label="10分钟" value="10"></el-option>
            <el-option label="15分钟" value="15"></el-option>
            <el-option label="半小时" value="30"></el-option>
            <el-option label="一小时" value="60"></el-option> -->



              <!-- <el-option
                :label="v.serviceType"
                :value="v.id"
                v-for="(v, i) in serviceTypeList"
                :key="i"
              ></el-option> -->
            <!-- </el-select> -->
          </el-form-item>


          <el-form-item label="服务图片" prop="serviceImg">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              noCircle
              noSquare
              :width="800"
              :height="800"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mall' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="!ruleForm.serviceImg"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip"
              >（可设置1张，建议尺寸800x800px）</span
            >
            <div class="priview" v-if="ruleForm.serviceImg">
              <img :src="ruleForm.serviceImg" alt="服务图片" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          


          <!-- <el-form-item label="预约日期：" prop="subscribe">
            <el-date-picker
              v-model="ruleForm.subscribe"
              type="daterange"
              align="right"
              ref="subscribePicker"
              :picker-options="pickerOptions"
              start-placeholder="报名开始时间"
              end-placeholder="报名结束时间"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
            ></el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="可预约服务范围:" prop="">
            可预约当天
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              v-model.number="ruleForm.enableStartDay"
              placeholder="开始天数"
              maxlength="3"
            ></el-input>
            天后到
            <el-input
              type="number"
              style="width: 100px"
              size="small"
              clearable
              class="ml10 mr10 ipt"
              v-model.number="ruleForm.enableEndDay"
              placeholder="结束天数"
              maxlength="3"
            ></el-input>
            天后的日期范围<span class="danger">(填0则表示预约当天)</span>
          </el-form-item> -->

          <!-- <el-form-item label="服务时间段:" prop="timeQuantumRelModelList">
            <el-time-select
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
              }"
            >
            </el-time-select>
            <span class="ml10 mr10">至</span>
            <el-time-select
              placeholder="结束时间"
              class="mr10"
              v-model="endTime"
              :picker-options="{
                start: '08:00',
                step: '00:30',
                end: '23:00',
                minTime: startTime,
              }"
            >
            </el-time-select>
            <el-button
              type="primary"
              @click="addTimeList"
              size="mini"
              icon="hmicon icon-hao"
              circle
            ></el-button>
            <div v-if="ruleForm.timeQuantumRelModelList.length > 0">
              <div>已选时段</div>
              <div class="timeList">
                <div
                  class="timeListItem mb10"
                  v-for="(item, index) in ruleForm.timeQuantumRelModelList"
                  :key="index"
                >
                  <div v-if="item.isshow">
                    <span class="text mr10">
                      {{ item.startTimeQuantum }}至{{ item.endTimeQuantum }}</span
                    >
                    <el-button
                      type="warning"
                      @click="deleteCurrentTime(index)"
                      class="ml10"
                      size="mini"
                      icon="hmicon icon-jianhao"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item> -->



          <h4>预约信息</h4>


          <!-- <el-form-item label="技师预约上限:" prop="singleTechnicianLimitNum">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              type="number"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.singleTechnicianLimitNum"
              placeholder="请填写正整数"
            ></el-input>
            <span class="danger">单个技师每时段内可预约人数上限</span>
          </el-form-item>
          <el-form-item label="单人预约上限:" prop="singleMemberLimitNum">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              type="number"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.singleMemberLimitNum"
              placeholder="请填写正整数"
            ></el-input>
            <span class="danger">单人每时段内可预约人数上限</span>
          </el-form-item> -->


          <el-form-item label="报名答题" prop="qaMode">
            <el-radio-group v-model="ruleForm.qaMode">
              <el-radio label="open">开启</el-radio>
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
            <div class="form-tip">开启后，则需要答对题目才能进行预约</div>
            <div v-if="ruleForm.qaMode==='open'">
            <div v-for="(v, i) in answerList" :key="i">
              <div class="mt20">题目{{i + 1}}:
                <el-input
                  style="width: 380px"
                  size="small"
                  clearable
                  class="mrl10 mr10 ipt"
                  v-model.trim="v.questions"
                  placeholder="请输入题目"
                ></el-input>
                <el-button type="primary" size="small" @click="deleteQuestions(i)">删除</el-button>
              </div>
              <div>答案类型:
                <el-select
                  size="small"
                  style="width: 380px"
                  clearable
                  placeholder="答案类型"
                  v-model="v.answerType"
                >
                  <el-option
                    :label="item.name"
                    :value="item.columnType"
                    v-for="(item, index) in answerTypeList"
                    :key="index"
                  ></el-option>
                </el-select>
                <div v-if="v.answerType === 'radio'">
                  <div class="flex item-center" v-for="(item, index) in v.radioList" :key="index">
                    <el-radio v-model="v.radio" :label="index">正确答案</el-radio>
                    <el-input
                      style="width: 230px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="item.answerInp"
                      placeholder="请输入答案"
                    ></el-input>
                    <div
                      class="minus-wrapper flex flex-center"
                      v-if="index===0"
                    >
                      <span
                        class="hmicon icon-hao pointer"
                        @click="addRadio(i)"
                      ></span>
                    </div>
                    <div
                      class="minus-wrapper flex flex-center"
                      v-else
                    >
                      <span
                        class="hmicon icon-jianhao pointer"
                        @click="delradio(i,index)"
                      ></span>
                    </div>
                  </div>
                </div>
                <!-- <div v-else-if="v.answerType === 'inp'">
                  正确答案:
                  <el-input
                    style="width: 230px"
                    size="small"
                    clearable
                    class="mrl10 mr10 ipt"
                    v-model.trim="v.answerInp"
                    placeholder="请输入答案"
                  ></el-input>
                </div> -->
                <div v-else-if="v.answerType === 'checkbox'">
                  <el-checkbox-group v-model="v.checkList">      
                    <div class="flex item-center" v-for="(item, index) in v.checkboxList" :key="index">           
                      <el-checkbox :label="index">
                        <div class="flex item-center">
                          <div class="mr20">正确答案</div>
                          <el-input
                            style="width: 230px"
                            size="small"
                            clearable
                            class="ml10 mr10 ipt"
                            v-model.trim="item.answerInp"
                            placeholder="请输入答案"
                          ></el-input>                            
                        </div>
                      </el-checkbox>
                      <div
                        class="minus-wrapper flex flex-center"
                        v-if="index===0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addCheck(i)"
                        ></span>
                      </div>
                      <div
                        class="minus-wrapper flex flex-center"
                        v-else
                      >
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="delCheck(i,index)"
                        ></span>
                      </div>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <el-button type="primary mt20" @click="addQuestions">添加题目</el-button>
            </div>
          </el-form-item>


          <el-form-item label="报名表单：" prop="formStatus">
            <el-radio-group v-model="ruleForm.formStatus">
              <el-radio label="open">开启</el-radio>
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
            <hm-form ref="hmform" v-if="ruleForm.formStatus === 'open'">
            </hm-form>
          </el-form-item>



          <!-- <el-form-item label="预约必填">
            <ul class="reservation-is-required">
              <li>姓名</li>
              <li>手机号</li>
              <li>宝宝年龄</li>
              <li>性别</li>
            </ul>
          </el-form-item> -->

          <el-form-item label="温馨提示">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="ruleForm.qaWarmHint">
            </el-input>
          </el-form-item>  



          <!-- <el-form-item label="添加模式" prop="schedulingMode">
            <el-radio-group v-model="ruleForm.schedulingMode">
              <el-radio label="add">手动填写</el-radio>
              <el-radio label="import">导表</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务门店:" prop="shopId">
            <div class="location-list">
              <div
                class="location-item"
                v-for="(item, index) in ruleForm.shopRelModelList"
                :key="index"
              >
                <div class="mb10">
                  <el-select
                    size="small"
                    style="width: 300px"
                    placeholder="请选择服务门店"
                    v-model="item.shopId"
                    class="ml10 mr10"
                    @change="changeShop(item)"
                  >
                    <el-option
                      :label="v.shopName"
                      :value="v.shopId"
                      v-for="(v, i) in shopList.records"
                      :key="i"
                    ></el-option>
                  </el-select>
                  <el-switch
                    v-model="item.enabledState"
                    active-color="#2d8"
                    inactive-color="#ff4949"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="yes"
                    inactive-value="no"
                    class="mr10"
                  ></el-switch>
                  <el-button
                    type="primary"
                    v-if="index === 0"
                    @click="addLocationItem"
                    size="mini"
                    icon="hmicon icon-hao"
                    circle
                  ></el-button>
                  <el-button
                    type="warning"
                    v-else
                    @click="deleteCurrentLocation(index)"
                    size="mini"
                    icon="hmicon icon-jianhao"
                    circle
                  ></el-button>
                  <span class="ml20 red danger">(门店处于关闭状态时，将不在手机端显示)</span>
                </div>
                <div class="flex" v-if="ruleForm.schedulingMode==='import' && item.shopId">
                  <div @click="outputExcel" class="delete mr20 pointer">
                      <span class="delete-icon hmicon icon-daochu"></span>
                      导出模板
                  </div>
                  <div class="pointer mr10 open-file">                  
                    <span class="hmicon icon-daoru"></span>
                      上传表格导入
                      <input
                        type="file"
                        @change="importfChange($event, item.shopId, item)"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    <span class="ml20 success" v-if="item.dateList.length>0">(已上传)</span>
                    <span class="ml20 red danger">(导入表格之前,先确认预约日期和预约时间段已填写完毕,保存成功才能看到表格数据)</span>
                  </div>
                </div>
                <div class="flex item-center" v-if="ruleForm.schedulingMode==='add' && item.shopId">
                  <span class="mr20">服务技师</span>
                  <el-button
                    type="primary"
                    size="small"
                    @click="openDialogVisibleEmp(item)"
                    >新增</el-button
                  >
                </div>
                <el-table
                  stripe
                  border
                  :data="item.empRelModelList"
                  style="width: 100%"
                  class="mt10"
                  id="table"
                  size="small"
                  v-if="ruleForm.schedulingMode==='add' && item.shopId"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    :index="(index) => index + (currentPage - 1) * pageSize + 1"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="realname"
                    label="职员名称"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="workNum"
                    label="工号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="enabledState"
                    label="显示状态"
                  >
                  <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.enabledState"
                    active-color="#2d8"
                    inactive-color="#ff4949"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="yes"
                    inactive-value="no"
                    class="mr10"
                  ></el-switch>
                  </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-form-item>
 -->

        
        



<!-- 
          <el-form-item label="活动状态：">
            <el-switch
              v-model="ruleForm.enabledState"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </el-form-item> -->


          <h4>服务设置</h4>
            <el-form-item label="同一个技师同一时段最多可预约" label-width="220px">
            <el-input
              style="width: 60px"
              size="small"
              clearable
              type="number"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.serviceStaffReservationNumber"
              placeholder=""
            ></el-input>
            <span>人</span>
            <!-- <span class="danger">单个技师每时段内可预约人数上限</span> -->
          </el-form-item>
          <el-form-item label="回访间隔(天数)">
            <el-input
              style="width: 60px"
              size="small"
              clearable
              type="number"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.returnVisit"
              placeholder=""
            ></el-input>
           <span>天</span>
            <!-- <span class="danger">单人每时段内可预约人数上限</span> -->
          </el-form-item>


          <h4>服务记录表单</h4>

          <el-form-item label="">
            <el-radio-group v-model="ruleForm.collectMode">
              <el-radio label="open">开启</el-radio>              
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>

            <el-checkbox-group v-if="ruleForm.collectMode == 'open'" v-model="ruleForm.collectContent">
              <el-checkbox label="上传图片"></el-checkbox>
              <el-checkbox label="填写服务文本"></el-checkbox>
              <el-checkbox label="上传视频"></el-checkbox>
            </el-checkbox-group>

          </el-form-item>



          
          <h4>服务启用状态</h4>
          <el-form-item label="启用状态">
            <el-switch
              v-model="ruleForm.isEnabled"
              active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>

          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <hm-filter-employee
      selectType="multiple"
      v-if="dialogVisibleEmp"
      @setMultipleEmpInfo="setMultipleEmpInfo"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
    ></hm-filter-employee>
  </div>
</template>

<script>
import HmFilterEmployee from "@/components/HmFilterEmployee";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { getLoginUser } from "@/utils/auth";
import { compare } from "@/utils/utils";
import HmForm from "@/components/HmForm";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import * as XLSX from 'xlsx/xlsx'
import { string } from 'xlsx/jszip';
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { myUpload, HmRichEditor, HmForm, actPreview ,HmFilterEmployee },
  data() {
    const patternActivityDate = (rule, val, callback) => {
      this.$refs.ruleForm.validateField("subscribe");
      callback();
    };
    const patternQaMode = (rule, val, callback) => {
      if (val === "open") {
        console.log(this.answerList);
        if (this.answerList.length === 0) {
          return callback(new Error("请添加题目"));
        }
        let flag = false;
        this.answerList.forEach(v=>{
          if(!v.answerType && !v.questions && v.radioList.length > 0){
            flag = true;
          }
        })
        if(flag) {
          return callback(new Error("请配置完整题目"));
        }

      }
      callback();
    };
    const patternFormStatus = (rule, val, callback) => {
      if (val === "open") {
        console.log(this.$refs.hmform.list);
        if (this.$refs.hmform.list.length === 0) {
          return callback(new Error("请选择表单"));
        } else {
          let flag = false;
          this.$refs.hmform.list.forEach((v) => {
            if (v.columnValue === "") {
              flag = true;
            }
            if (v.columnType === "radio") {
              v.paramInfoModels.forEach((o) => {
                if (o.columnValue === "") {
                  flag = true;
                }
              });
            }
          });
          if (flag) {
            return callback(new Error("请把表单填写完整"));
          }
        }
      }
      callback();
    };
    const patternListHeader = function (rule, val, callback) {
      if (!this.ruleForm.serviceImg) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      currentPageAuth: 1,
      pageSizeAuth: 10,
      totalAuth: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      startTime: "",
      endTime: "",
      serviceTypeList: [],
      showDetail: false,
      show: false,
      inputVisible: false,
      dialogVisibleEmp: false,
      row: {},
      allEmployeeList: [],
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      hasAuthList: [],      
      row: {},
      uploadedDetailList: [],      
      ruleForm: {
        id:'',
        projectTypeId:'',
        serviceName:'',
        serviceCode:'',
        sort:'',
        serviceDescribe:'',
        serviceDuration:'',
        serviceImg:'',
        qaMode:'close',
        columnType:'',
        qaWarmHint:'',
        serviceStaffReservationNumber:'',
        returnVisit:'',
        collectMode:'close',
        collectContent:[],
        qaContent:"{}",
        isEnabled: true,
        // serviceTypeId: "",
        // serviceName: "",
        // subscribeStartDate: "",
        // subscribeEndDate: "",
        // enableStartDay: "",
        // enableEndDay: "",
        // serviceImg: "",
        // shopRelModelList: [
        //   {
        //     shopId: "",
        //     enabledState: "yes",
        //     empRelModelList: [],
        //     isShowDateList: false,
        //     dateList: [],
        //   },
        // ],
        // timeQuantumRelModelList: [],
        formStatus: "open",
        // enabledState: "yes",
        // subscribe: [],
        // schedulingMode: "add",
        // qaMode: "close",
      },
      rules: {        
        formStatus: [
          {
            required: true,
            message: "请选择表单状态",
            trigger: "blur",
          },
          { required: true, validator: patternFormStatus, trigger: "change" },
        ],
        qaMode: [
          {
            required: true,
            message: "请选择答题状态",
            trigger: "blur",
          },
          { required: true, validator: patternQaMode, trigger: "change" },
        ],
        // serviceTypeId: [
        //   { required: true, message: "请选择服务类型", trigger: "change" },
        // ],
        serviceName: [
          { required: true, message: "请输入服务名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" },
        ],
      //   subscribe: [
      //     { required: true, message: "请选择预约日期", trigger: "change" },
      //   ],
      //   singleTechnicianLimitNum:[{
      //       required: true,
      //       pattern: /^[1-9]\d*$/,
      //       message: "请输入正整数",
      //       trigger: "blur"
      //       }
      //   ],
      //   singleMemberLimitNum:[{
      //       required: true,
      //       pattern: /^[1-9]\d*$/,
      //       message: "请输入正整数",
      //       trigger: "blur"
      //       }
      //   ],
      serviceImg: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur",
          },
        ],
      },
      answerTypeList:[
        {
          columnType: "radio",
          name: "单选题",
        },
        {
          columnType: "inp",
          name: "单行文本",
        },
        {
          columnType: "checkbox",
          name: "多选题",
        },
      ],
      answerList:[],
      uploadShow: true,
    };
  },
  watch: {},
  async created() {
    await this.queryServiceRestorationTypeList();
    this.getServiceRestorationProjectInfo();
  },
  mounted() {
    
  },
  computed: mapGetters(["storeStyle", "shopList"]),
  methods: {
    // storeServiceProjectInfoQueryById
    async getServiceRestorationProjectInfo() {
      console.log("this.$route.query.id:", this.$route.query.id);
      const { result } = await this.$store.dispatch(
        "storeServiceProjectInfoQueryById",
        {
          id: this.$route.query.id,
        }
      );
    
      if(result.collectContent && result.collectContent.length > 0){
        result.collectContent = result.collectContent.split(',');
      }else{
        result.collectContent = [];
      }

      if(result.isEnabled == 'open'){
        result.isEnabled = true;
      }else {
        result.isEnabled = false;
      }
      result.serviceDuration = String(result.serviceDuration);
      this.ruleForm = result;
      if(this.ruleForm.qaContent==="{}" || !this.ruleForm.qaContent){
        this.answerList = [];
      }else{
        this.answerList = JSON.parse(this.ruleForm.qaContent);
      }
      setTimeout(() => {
        if (this.$refs.hmform) {
          this.$refs.hmform.list = result.columnsInfoModels;
        }
      }, 1000);
    },



    changeShop(item){
      this.row = item;
    },
    setMultipleEmpInfo(info) {
      info.forEach((v) => {
        v.id = ""
        v.enabledState = "yes"
      })
      console.log("this.row:",this.row);
      console.log("info:",info);
      let info2=JSON.parse(JSON.stringify(info));
      this.row.empRelModelList.push(...info2);
      this.dialogVisibleEmp = false;      
      this.$forceUpdate();
    },
    async queryAllEmployee() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        loginType: "store",
        workingState: "yes"
      };
      const { result } = await this.$store.dispatch(
        "queryAllEmployeeList",
        params
      );
      this.allEmployeeList = result.records;
    },
    openDialogVisibleEmp(row){
      this.row = row;
      this.dialogVisibleEmp = true;
    },
   
    async queryServiceRestorationTypeList() {
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationTypeList"
      );
      if (result) {
        this.serviceTypeList = result;
      }
    },

    deleteCurrentTime(index) {
      this.ruleForm.timeQuantumRelModelList.splice(index, 1);
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.serviceImg = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.answerList.length > 0){
             let isfull = true;
             this.answerList.forEach(v=>{
                if(v.answerType === 'radio' && v.radio === ""){
                  isfull = false;
                  return;
                }
                if(v.answerType === 'checkbox' && v.checkList.length === 0){
                  isfull = false;
                  return;
                }
             })
             if(!isfull){
              this.$message({
                message: "请至少选择一个正确答案",
                type: "warning",
              });
              return false;
             }
          }
          if(this.answerList.length >= 0 ){
            this.ruleForm.qaContent = JSON.stringify(this.answerList);
          }
          let params = JSON.parse(JSON.stringify(this.ruleForm));


          
          let columnsInfoModels = [];
          if (this.$refs.hmform) {
            columnsInfoModels = this.$refs.hmform.list;
          }
          params = Object.assign(params, {
            columnsInfoModels,
          });
          console.log("888888", params.collectContent);


          if(params.collectContent){
            params.collectContent = params.collectContent.join(',');
          }

          console.log("params", params);

          const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]+$/;
          //params.serviceCode 最长8个字符，英文+数字，分类+编码，组成分类编码
          if(params.serviceCode){
            if (!regex.test(params.serviceCode) || params.serviceCode.length > 8 || params.serviceCode.length < 0) {
              this.$message({
                message: "编码只能是1-8位英文或数字，且不能包含特殊字符",
                type: "warning",
              });
              return;
            }
          }
          params.isEnabled=params.isEnabled===true?'open':'close';
          params = {...params, id: this.$route.query.id}
          this.$store
            .dispatch("editServiceDateRule", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.back(-1);
                }
              //   if(this.ruleForm.schedulingMode==='import')
              //   {
              //     let resultID = res.result;
              //     console.log("resultID:",resultID);
              //     this.$message({
              //       message: "操作成功",
              //       type: "success",
              //     });
              //     this.$router.back(-1);
              //   }else{
              //     this.$message({
              //       message: "操作成功",
              //       type: "success",
              //     });
              //     this.$router.back(-1);
              //   }
              // }
            });

            




        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.serviceImg = "";
    },
    // 上传成功后的回调
    addQuestions(){
      console.log(this.answerList);
      this.answerList.push({
        questions: "",
        answerType: "",
        radio: "",
        answerInp: "",
        radioList:[
          {
            answerInp: "",
          }
        ],
        checkList:[],
        checkboxList:[
          {
            answerInp: "",
          }
        ]
      })
    },
    deleteQuestions(index){
      this.answerList.splice(index, 1);
      console.log(this.answerList);
    },
    addRadio(i) {
      this.answerList[i].radioList.push({ answerInp: "" });
    },
    delradio(i, index) {
      this.answerList[i].radioList.splice(index, 1);
    },
    addCheck(i){
      this.answerList[i].checkboxList.push({ answerInp: "" });
    },
    delCheck(i, index) {
      this.answerList[i].checkboxList.splice(index, 1);
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "xls" 
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "xlsx";
      if (!extension && !extension2) {
        this.$message({
          message: "上传模板只能是 xls、xlsx格式!",
          type: "warning"
        });
      }
      return extension || extension2;
    },
    uploading() {
      this.uploadShow = true;
    },
    uploadExcelSucc(){

    },
    // importfChange(e,shopId,item) {
    //     const obj = e.target;
    //     const that = this;
    //     this.inputData = [];
    //     if (!obj.files) {
    //       return;
    //     }
    //     let f = obj.files[0];
    //     let reader = new FileReader();
    //     reader.onload = function (e) {
    //       let data = e.target.result;
    //       if (rABS) {
    //         wb = XLSX.read(btoa(this.fixdata(data)), {
    //           // 手动转化
    //           type: "base64",
    //         });
    //       } else {
    //         wb = XLSX.read(data, {
    //           type: "binary",
    //         });
    //       }
    //       let resultAll = null;
    //       wb.SheetNames.forEach((sheetName) => {
    //         let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
    //           header: 1,
    //         });
    //         if (roa.length) {
    //           resultAll = roa;
    //         }
    //       });
    //       let list = resultAll;
    //       console.log("resultAll:", resultAll);
    //       item.dateList = list;
    //       that.$message({
    //         message: "上传成功,提交后导入表格",
    //         type: "success",
    //       });
    //     };
    //     if (rABS) {
    //       reader.readAsArrayBuffer(f);
    //     } else {
    //       reader.readAsBinaryString(f);
    //     }
    //     obj.value = "";
    //   },



      async importEmployeeSchedulingData(id,shopId,list){
        let params = {
          projectId: id,
          shopId: shopId,
          employeeSchedulingData: list,
        };
        await this.$store.dispatch("importEmployeeSchedulingData", params).then((res) => {
          const { code } = res;
          if (code === "0") {
            // this.getschedulingInfoListByshopId(shopId,item);
            this.$message({
              message: "导入成功",
              type: "success",
            });
          }
        });
      },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "部门",
          "工号",
          "姓名",
          "2022-07-14",
          "2022-07-15",
          "2022-07-16",
          "2022-07-16"
        ];
        const data = [
          ["商店信息", "ABC123", "禾苗测试", "早班（8:30-17:00）", "中班（10:30-18:30）", "晚班（13:00-21:00）", "休息"]
        ];
        exportJsonToExcel(tHeader, data, "服务预约排版模板");
      });
    },
  },
};
</script>

<style scoped lang="scss">
h4 {
  height: 22px;
  font-weight: 500;
  font-size: 16px;
  color: #222222;
  line-height: 19px;
  position: relative;
}
h4::before {
  content: '';
  width: 3px;
  height: 14px;
  background: #E50065;
  border-radius: 2px 0px 2px 0px;
  display: block;
  position: absolute;
  left: -10px;
  bottom: 5px;
}
.timeListItem {
  .text {
    width: 356px;
    height: 20px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 12px;
    line-height: 20px;
    display: inline-block;
  }
}
.priview {
  position: relative;
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.event-details-table {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  .table-header {
    background: #f7f7f7;
    padding: 0 10px;
    .title {
      text-align: center;
    }
  }
  .activity-item {
    padding: 0 10px;
    .ipt-wrapper {
      box-sizing: border-box;
      .el-input {
        width: 80%;
      }
    }
  }
}

.location-item:not(:last-child) {
  margin-bottom: 20px;
}

.actCostMoney {
  padding-right: 75px;
  .tip {
    color: #999;
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 100%;
    flex-shrink: 0;
  }
}
.reservation-is-required {
  width: 600px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: #f7f7f7;
}
</style>
